import Grow from '@material-ui/core/Grow';
import { WithStyles } from 'decorators/withStyles';
import React, { Fragment, PureComponent } from 'react';

interface IProps {
  width: string;
  height: string;
  list?: boolean;
  classes?: any;
}

@WithStyles(() => ({
  root: {
    height: '100%',
    backgroundColor: '#ccc',
    borderEadius: '25%',
    backgroundImage: 'linear-gradient(90deg, #F4F4F4 0px, rgba(229, 229, 229, 0.8) 40px, #F4F4F4 80px)',
    backgroundSize: '600px',
    animation: 'loading 2s infinite ease-out'
  }
}))
export default class DivLoader extends PureComponent<IProps> {
  renderList = () => {
    let arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    const { width, height } = this.props;
    return arr.map((arr, i) => {
      return (
        <Grow key={i} in={true} timeout={500 * i > 3000 ? 3000 : 500 * i}>
          <div className={`skeletonComponent listItem`} style={{ width, height }} />
        </Grow>
      );
    });
  };

  render() {
    const { width, height, list } = this.props;

    return (
      <Fragment>
        <style>
          {`
            .skeletonComponent {
              height: 100%;
              width: 100%;
              background: linear-gradient(-90deg, #efefef 0%, #fcfcfc 50%, #efefef 100%);
              background-size: 400% 400%;
              animation: pulse 1.2s ease-in-out infinite;
            }

            @keyframes pulse {
               0% {
                background-position: 0% 0%;
              }
              100% {
                background-position: -135% 0%;
              }
            }

            .listItem {
              margin: 10px 0;
            }
    `}
        </style>
        {!list ? <div className={`skeletonComponent`} style={{ width, height }} /> : this.renderList()}
      </Fragment>
    );
  }
}
